module.exports = __webpack_public_path__ + "img/entebowlfront.ad7d04b7.png";